import { postCall, postFormCall, dispatchAppropirateResponse, interceptor } from "../../networking";
import * as types from "./types/account.types";
import * as signupTypes from "../actions/types/onboarding.types";
import { urls } from "../../networking/url";
import * as newtypes from "./types/signatory.types";

export const createTransactionPin = (data) => async (dispatch) => {
    dispatch({ type: types.CREATE_TRAN_PIN_STARTED });
    try {
        const response = await postCall(urls.createPin, data);
        const result = dispatchAppropirateResponse(
            response,
            {
                type: types.CREATE_TRAN_PIN_SUCEEDED,
                payload: response.data.message,
            },
            { type: types.CREATE_TRAN_PIN_FAILED, payload: response.data.message },
            dispatch,
        );
        return result;
    } catch (err) {
        dispatch({
            type: types.CREATE_TRAN_PIN_FAILED,
            payload: "Please check your internet connection and try again!",
        });
        return false;
    }
};

export const fetchUserAccountBalance = (payload, callType) => async (dispatch) => {
    dispatch({
        type:
            callType && callType === "refresh"
                ? types.REFRESH_PAYMENT_BALANCE_STARTED
                : callType === "fireStoreCall"
                ? types.FETCH_ACC_BALANCE_STARTED_FIRESTORE
                : types.FETCH_ACC_BALANCE_STARTED,
    });

    try {
        const response = await postCall(urls.getAccountBalance, payload);
        const time = new Date();
        const result = dispatchAppropirateResponse(
            response,
            {
                type:
                    callType && callType === "refresh"
                        ? types.REFRESH_PAYMENT_BALANCE_SUCCESS
                        : types.FETCH_ACC_BALANCE_SUCCEDEED,
                payload: {
                    message: response.data.message,
                    data: { ...response.data.customerAccountBalance, lastUpdated: time },
                },
            },
            {
                type:
                    callType && callType === "refresh"
                        ? types.REFRESH_PAYMENT_BALANCE_FAILED
                        : types.FETCH_ACC_BALANCE_FAILED,
                payload: response.data.message,
            },
            dispatch,
        );
        return result;
    } catch (err) {
        dispatch({
            type:
                callType === "refresh"
                    ? types.REFRESH_PAYMENT_BALANCE_FAILED
                    : types.FETCH_ACC_BALANCE_FAILED,
            payload: err,
        });
    }
};

// HIDE_ERROR_MODAL

export const hideErrorModal = () => (dispatch) => {
    dispatch({ type: types.HIDE_ERROR_MODAL });
};

export const toggleBalanceDisplay = () => (dispatch) => {
    dispatch({ type: types.TOGGLE_BALANCE_DISPLAY });
};

export const fetchUserSMEProfiles = (data) => async (dispatch) => {
    dispatch({ type: types.FETCH_USER_INFO_STARTED });
    try {
        const response = await postCall(urls.retrieveSMEProfile, data);
        if (response.data.isSuccessful === true) {
            dispatch({
                type: types.FETCH_USER_INFO_SUCEEDED,
                payload: {
                    data: response.data.data,
                    message: response.data.message,
                },
            });
        } else if (response.isSuccessful === false) {
            dispatch({
                type: types.FETCH_USER_INFO_FAILED,
                payload: response.data.message,
            });
        }
    } catch (err) {
        dispatch({
            type: types.FETCH_USER_INFO_FAILED,
            payload: err,
        });
    }
};

export const inviteSignatory = (data, successFn, failureFn) => async (dispatch) => {
    dispatch({ type: types.ADD_SIGNATORY_STARTED });
    try {
        const response = await postCall(urls.inviteSignatory, data);
        if (response.data.isSuccessful === true) {
            dispatch({
                type: types.ADD_SIGNATORY_SUCCEEDED,
                payload: {
                    message: response.data.message,
                    data: data,
                },
            });
            successFn();
            return {
                status: true,
                message: response.data.message,
            };
        } else if (typeof response === "undefined") {
            dispatch({
                type: types.ADD_SIGNATORY_FAILED,
            });
            failureFn("Unable to add signatory. Please, try again!");
            return {
                status: false,
                message: response.data.message,
            };
        } else if (response === "Token Expired") {
            dispatch({
                type: types.ADD_SIGNATORY_FAILED,
            });
            failureFn("Your token has expired. Login to try again!");
            return {
                status: false,
                message: response.data.message,
            };
        } else if (response.isSuccessful === false) {
            dispatch({
                type: types.ADD_SIGNATORY_FAILED,
                payload: response.data.message,
            });
            return {
                status: false,
                message: response.data.message,
            };
        }
    } catch (err) {
        dispatch({
            type: types.ADD_SIGNATORY_FAILED,
            payload: err,
        });
        failureFn("Unable to add signatory. Please, try again!");
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const setInviteSignatoryObj = (key, value) => (dispatch) => {
    dispatch({
        type: types.SET_SIGNATORY_OBJ,
        payload: {
            key: key,
            value: value,
        },
    });
};

export const setStateObj = (data) => (dispatch) => {
    dispatch({
        type: types.SET_STATE_DATA,
        payload: data,
    });
};

export const setLGA = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LGA,
        payload: value,
    });
};

export const setEditSteps = (count) => (dispatch) => {
    dispatch({ type: types.INCREASE_STEP, payload: count });
};

export const showPhoneComponent = (value) => (dispatch) => {
    dispatch({
        type: types.SHOW_PHONE_COMPONENT,
        payload: value,
    });
};

export const showAddressComponent = (value) => (dispatch) => {
    dispatch({
        type: types.SHOW_ADDRESS_COMPONENT,
        payload: value,
    });
};

export const showKinComponent = (value) => (dispatch) => {
    dispatch({
        type: types.SHOW_KIN_COMPONENT,
        payload: value,
    });
};

export const showCompanyProfileComponent = (value) => (dispatch) => {
    dispatch({
        type: types.SHOW_COMPANY_PROFILE_COMPONENT,
        payload: value,
    });
};

export const resetEditCount = () => (dispatch) => {
    dispatch({
        type: types.RESET_STEPS,
    });
};

export const updateSMEProfile = (data) => async (dispatch) => {
    dispatch({ type: types.UPDATE_SME_PROFILE_STARTED });
    try {
        const response = await postCall(urls.updateSMEProfile, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.UPDATE_SME_PROFILE_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.UPDATE_SME_PROFILE_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.UPDATE_SME_PROFILE_FAILED,
                });
                interceptor(status, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.UPDATE_SME_PROFILE_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_SME_PROFILE_FAILED,
        });
        return false;
    }
};

export const updateSMEBusinessAddress = (data) => async (dispatch) => {
    dispatch({ type: types.UPDATE_SME_BUSINESS_ADDRESS_STARTED });
    try {
        const response = await postCall(urls.updateBusinessAddress, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.UPDATE_SME_BUSINESS_ADDRESS_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.UPDATE_SME_BUSINESS_ADDRESS_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.UPDATE_SME_BUSINESS_ADDRESS_FAILED,
                });
                interceptor(status, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.UPDATE_SME_BUSINESS_ADDRESS_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_SME_BUSINESS_ADDRESS_FAILED,
        });
        return false;
    }
};

export const setSmeProfile = (data) => (dispatch) => {
    dispatch({
        type: types.SELECT_SME_PROFILE,
        payload: {
            accounts: data.accounts[0],
            businessProfile: data.businessProfile,
            nominee: data.nominee,
            data: data,
        },
    });
};

/**
 * It makes a post call to the url `urls.retrieveGroups` with the data passed to it, and if the
 * response is successful, it dispatches an action of type `signupTypes.FETCH_SME_PROFILES_SUCCEEEDED`
 * with the response data as payload. If the response is not successful, it dispatches an action of
 * type `signupTypes.FETCH_SME_PROFILES_FAILED` with the response as payload
 * @param data - This is the data you want to send to the API.
 * @param kudaSmeID - This is the ID of the SME profile you want to retrieve.
 * @returns A function that returns a function that returns a boolean or a string.
 */
export const refreshSmeProfile = (data, kudaSmeID) => async (dispatch) => {
    try {
        const response = await postCall(urls.retrieveGroups, data);
        if (response?.data?.isSuccessful === true) {
            dispatch({
                type: signupTypes.FETCH_SME_PROFILES_SUCCEEEDED,
                payload: response.data.data,
            });
            const getUserObj = response.data.data.groups.find((o) => o?.id === kudaSmeID);

            dispatch({
                type: types.SELECT_SME_PROFILE,
                payload: {
                    accounts: getUserObj?.accounts?.[0],
                    businessProfile: getUserObj?.businessProfile,
                    nominee: getUserObj?.nominee,
                    data: getUserObj,
                    raw: response.data.data,
                },
            });
            return true;
        } else if (response?.data?.statusCode === "k-SME-10") {
            dispatch({
                type: signupTypes.FETCH_SME_PROFILES_FAILED,
                payload: response,
            });
            return "No sme profile found";
        }
    } catch (err) {
        dispatch({
            type: signupTypes.FETCH_SME_PROFILES_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return false;
    }
};

export const createWithExistingAccInfo = (data, others) => async (dispatch) => {
    dispatch({ type: types.CREATE_WITH_ACC_INFO_START });
    try {
        const response = await postCall(urls.createWithExistingAccInfo, data);
        if (response.data.isSuccessful === true) {
            dispatch({
                type: types.CREATE_WITH_ACC_INFO_SUCCESS,
                payload: {
                    smeProfileID: response.data.id,
                    signatoryID: response.data.signatoryID,
                    data: data,
                    others: others,
                },
            });
            return {
                status: true,
                id: response.data.id,
            };
        } else if (
            response.data.isSuccessful === false &&
            response.data.message === "A record exists with the CAC number supplied."
        ) {
            dispatch({
                type: types.CREATE_WITH_ACC_INFO_FAILED,
                payload: response.data.message,
            });
            return "A record exists with the CAC number supplied.";
        } else if (response.data.isSuccessful === false) {
            dispatch({
                type: types.CREATE_WITH_ACC_INFO_FAILED,
                payload: response.data.message,
            });
            return {
                status: false,
            };
        }
    } catch (err) {
        dispatch({
            type: types.CREATE_WITH_ACC_INFO_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
        };
    }
};

export const updatePinState = () => (dispatch) => {
    dispatch({
        type: types.UPDATE_PIN_STATE,
    });
};

export const uploadSmeLimitedDocs = (data, fileName, name) => async (dispatch) => {
    dispatch({ type: types.UPLOAD_LIMITED_DOCS_STARTED });
    try {
        let headers = { "Content-Type": "multipart/form-data" };
        const response = await postFormCall(urls.businessDocUpdate, data, headers);
        if (response.data.isSuccessful === true) {
            dispatch({
                type: types.UPLOAD_LIMITED_DOCS_SUCEEDED,
                payload: {
                    name: name,
                    fileName: fileName,
                },
            });
            return true;
        } else {
            dispatch({
                type: types.UPLOAD_LIMITED_DOCS_FAILED,
                payload: response.data.message,
            });
            return false;
        }
    } catch (err) {
        dispatch({ type: types.UPLOAD_LIMITED_DOCS_FAILED, payload: err });
        return false;
    }
};

export const uploadProfilePhoto = (data, fileUrl) => async (dispatch) => {
    dispatch({ type: types.CHANGE_PROFILE_PHOTO_STARTED });
    try {
        let headers = { "Content-Type": "multipart/form-data" };
        const response = await postFormCall(urls.businessDocUpdate, data, headers);
        if (response.data.isSuccessful === true) {
            dispatch({
                type: types.CHANGE_PROFILE_PHOTO_SUCEEDED,
                payload: fileUrl,
            });
            return true;
        } else if (typeof response === "undefined") {
            dispatch({
                type: types.CHANGE_PROFILE_PHOTO_FAILED,
            });
            return false;
        } else if (response.data.isSuccessful === false) {
            dispatch({
                type: types.CHANGE_PROFILE_PHOTO_FAILED,
                payload: response.data.message,
            });
            return false;
        } else {
            dispatch({
                type: types.CHANGE_PROFILE_PHOTO_FAILED,
                payload: response.data.message,
            });
            return false;
        }
    } catch (err) {
        dispatch({ type: types.CHANGE_PROFILE_PHOTO_FAILED, payload: err });
        return false;
    }
};

export const setIndustrySme = (value) => (dispatch) => {
    dispatch({ type: types.SET_INDUSTRY, payload: value });
};

export const setInviteSignatoryInfo = (data) => (dispatch) => {
    dispatch({ type: types.SET_SIGNATORY_DATA, payload: data });
};

export const editSignatory = (data) => async (dispatch) => {
    dispatch({ type: types.UPDATE_SIGNATORY_STARTED });
    try {
        const response = await postCall(urls.updateSignatory, data);
        const { status } = response;
        if (status === 200) {
            if (response.data.isSuccessful) {
                dispatch({
                    type: newtypes.UPDATE_NEWSIGNATORY_SUCCEEDED,
                    payload: {
                        id: data.id,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        designation: data.designation,
                        dateOfBirth: data.dateOfBirth,
                        phoneNumber: data.phoneNumber,
                        roleID: data.roleID,
                        status: data.status,
                        address: data.address,
                        smeprofileid: data.smeprofileid,
                        userid: data.userid,
                        accessLevel: data.accessLevel,
                        dailyCummulativeAmountLimit: data.dailyCummulativeAmountLimit,
                        singleTransferAmountLimit: data.singleTransferAmountLimit,
                        overrideAccessLevelSingleLimit: data.overrideAccessLevelSingleLimit,
                        overrideAccessLevelDailyLimit: data.overrideAccessLevelDailyLimit,
                    },
                });
                dispatch({
                    type: types.UPDATE_SIGNATORY_SUCCEEDED,
                });
                return {
                    status: true,
                    message: response.data.message,
                };
            } else {
                dispatch({
                    type: types.UPDATE_SIGNATORY_FAILED,
                    payload: "Failed to fetch signatories",
                });
                return {
                    status: false,
                    message: response.data.message,
                };
            }
        } else {
            dispatch({
                type: types.UPDATE_SIGNATORY_FAILED,
                payload: "Failed to fetch signatories",
            });
            interceptor(response, dispatch);
            return {
                status: false,
                message: response,
            };
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_SIGNATORY_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const setCompanyInfo = (name, value) => (dispatch) => {
    dispatch({
        type: types.SET_COMPANY_DETAILS,
        payload: {
            name: name,
            value: value,
        },
    });
    // if (value === "Not Applicable") {
    //     dispatch({
    //         type: types.SET_SCUML_FILE,
    //         payload: "",
    //     });
    // }
};

export const setIsGetToKnowYou = () => (dispatch) => {
    dispatch({ type: types.SET_GET_TO_KNOW_YOU });
};

export const createNewAccount = (data) => async (dispatch) => {
    dispatch({ type: types.CREATE_KUDA_ACCOUNT_STARTED });
    try {
        const response = await postCall(urls.createKudaAccount, data);

        if (response.data.isSuccessful === true && response.data.statusCode === "k00") {
            dispatch({
                type: types.CREATE_KUDA_ACCOUNT_SUCCEEDED,
                payload: {
                    smeProfileID: response.data.id,
                    signatoryID: response.data.signatoryID,
                    accountNumber: response.data.accountNumber,
                    data: data,
                },
            });
            return {
                status: true,
                id: response.data.id,
            };
        } else if (
            response.data.isSuccessful === false &&
            response.data.message === "A record exists with the CAC number supplied."
        ) {
            dispatch({
                type: types.CREATE_KUDA_ACCOUNT_FAILED,
                payload: response.data.message,
            });
            return "A record exists with the CAC number supplied.";
        } else if (
            response.data.isSuccessful === false &&
            response.data.accountNumber &&
            response.data.statusCode !== "k00"
        ) {
            dispatch({
                type: types.CREATE_KUDA_ACCOUNT_FAILED,
                payload: response.data.message,
            });
            return "SMEProfile creation failed. Account number successful";
        } else if (
            response.data.isSuccessful === false &&
            !response.data.accountNumber &&
            response.data.statusCode !== "k00"
        ) {
            dispatch({
                type: types.CREATE_KUDA_ACCOUNT_FAILED,
                payload: response.data.message,
            });
            return {
                status: false,
            };
        } else {
            dispatch({
                type: types.CREATE_KUDA_ACCOUNT_FAILED,
                payload: response.data.message,
            });
            return {
                status: false,
            };
        }
    } catch (err) {
        dispatch({
            type: types.CREATE_KUDA_ACCOUNT_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
        };
    }
};

export const setScumlFile = (payload) => (dispatch) => {
    dispatch({ type: types.SET_SCUML_FILE, payload: payload });
};

export const approveIndemnity = (data, type) => async (dispatch) => {
    dispatch({
        type: types.APPROVE_INDEMNITY_LOADING,
    });
    try {
        const response = await postCall(urls.updateBusinessDetails, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    if (type === 2) {
                        dispatch({
                            type: types.APPROVE_LL_BN_INDEMNITY_SUCCEEDED,
                        });
                    }
                    dispatch({
                        type: types.APPROVE_INDEMNITY_SUCCEEDED,
                    });
                } else {
                    dispatch({
                        type: types.APPROVE_INDEMNITY_FAILED,
                    });
                }
                return response;
            } else {
                dispatch({
                    type: types.APPROVE_INDEMNITY_FAILED,
                });
                return false;
            }
        } else {
            dispatch({
                type: types.APPROVE_INDEMNITY_FAILED,
            });
            return false;
        }
    } catch (err) {
        dispatch({
            type: types.APPROVE_INDEMNITY_FAILED,
        });
        return false;
    }
};

export const approveTerms = (data) => async (dispatch) => {
    dispatch({
        type: types.APPROVE_TERMS_STARTED,
    });
    try {
        const response = await postCall(urls.acceptTerms, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.APPROVE_TERMS_SUCCEEDED,
                    });
                } else {
                    dispatch({
                        type: types.APPROVE_TERMS_FAILED,
                    });
                }
                return response;
            } else {
                dispatch({
                    type: types.APPROVE_TERMS_FAILED,
                });
                return false;
            }
        } else {
            dispatch({
                type: types.APPROVE_TERMS_FAILED,
            });
            return false;
        }
    } catch (err) {
        dispatch({
            type: types.APPROVE_TERMS_FAILED,
        });
        return false;
    }
};

export const showIndemnityAcceptedModal = () => async (dispatch) => {
    dispatch({ type: types.SHOW_INDEMNITY_ACCEPTED_MODAL });
};

export const closeIndemnityAcceptedModal = () => async (dispatch) => {
    dispatch({ type: types.CLOSE_INDEMNITY_ACCEPTED_MODAL });
};

export const getStatement = (data) => async (dispatch) => {
    dispatch({ type: types.GET_STATEMENT_STARTED });
    try {
        const response = await postCall(urls.getAccountStatement, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.GET_STATEMENT_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.GET_STATEMENT_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.GET_STATEMENT_FAILED,
                });
                interceptor(status, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.GET_STATEMENT_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.GET_STATEMENT_FAILED,
        });
        return false;
    }
};

export const getStatementNew = (data) => async (dispatch) => {
    dispatch({ type: types.GET_STATEMENT_STARTED });
    try {
        const response = await postCall(urls.getAccountStatement, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.GET_STATEMENT_SUCCEEDED,
                        payload: data,
                    });
                    return { status: true };
                } else {
                    dispatch({
                        type: types.GET_STATEMENT_FAILED,
                    });
                    return { status: false, message: response?.data?.message || "" };
                }
            } else {
                dispatch({
                    type: types.GET_STATEMENT_FAILED,
                });
                interceptor(status, dispatch);
                return { status: false, message: "" };
            }
        } else {
            dispatch({
                type: types.GET_STATEMENT_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.GET_STATEMENT_FAILED,
        });
        return { status: false, message: "" };
    }
};

export const verifyPhoneNumber = (data) => async (dispatch) => {
    dispatch({ type: types.VERIFY_PHONENUMBER_STARTED });
    try {
        const response = await postCall(urls.verifyPhoneNumber, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.VERIFY_PHONENUMBER_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.VERIFY_PHONENUMBER_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.VERIFY_PHONENUMBER_FAILED,
                });
                interceptor(status, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.VERIFY_PHONENUMBER_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.VERIFY_PHONENUMBER_FAILED,
        });
        return false;
    }
};

export const numberValidation = (data) => async (dispatch) => {
    dispatch({
        type: types.VALIDATE_USER_PHONENUMBER,
        payload: data,
    });
};

export const changeUserPhoneNumber = (data) => async (dispatch) => {
    dispatch({ type: types.USER_PHONENUMBER_CHANGE_STARTED });
    try {
        const response = await postCall(urls.vaidatePhoneNumberChange, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.USER_PHONENUMBER_CHANGE_SUCCEEDED,
                        payload: data.phoneNumber,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.USER_PHONENUMBER_CHANGE_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.USER_PHONENUMBER_CHANGE_FAILED,
                });
                interceptor(status, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.USER_PHONENUMBER_CHANGE_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.USER_PHONENUMBER_CHANGE_FAILED,
        });
        return false;
    }
};

export const setUserNOKRelationship = (value) => (dispatch) => {
    dispatch({ type: types.SET_USER_NOK_RELATIONSHIP, payload: value });
};

export const updateUserInfo = (data) => async (dispatch) => {
    dispatch({ type: types.USER_INFO_UPDATE_STARTED });
    try {
        const response = await postCall(urls.updateUserInfo, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.USER_INFO_UPDATE_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.USER_INFO_UPDATE_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.USER_INFO_UPDATE_FAILED,
                });
                interceptor(status, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.USER_INFO_UPDATE_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.USER_INFO_UPDATE_FAILED,
        });
        return false;
    }
};

export const updateUserAddress = (data) => async (dispatch) => {
    dispatch({ type: types.USER_INFO_UPDATE_STARTED });
    try {
        const response = await postCall(urls.updateUserAddress, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.USER_ADDRESS_UPDATE_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.USER_ADDRESS_UPDATE_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.USER_ADDRESS_UPDATE_FAILED,
                });
                interceptor(status, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.USER_ADDRESS_UPDATE_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.USER_ADDRESS_UPDATE_FAILED,
        });
        return false;
    }
};

export const uploadUserPhotoNew = (data, fileUrl) => async (dispatch) => {
    dispatch({ type: types.CHANGE_USER_PROFILE_PHOTO_STARTED });

    try {
        let headers = { "Content-Type": "multipart/form-data" };
        const response = await postFormCall(urls.uploadUserFileImage, data, headers);

        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.CHANGE_USER_PROFILE_PHOTO_SUCCEEDED,
                payload: fileUrl,
            });
        } else {
            dispatch({
                type: types.CHANGE_USER_PROFILE_PHOTO_FAILED,
            });
        }
        return response;
    } catch (err) {
        dispatch({
            type: types.CHANGE_USER_PROFILE_PHOTO_FAILED,
        });
        return {
            status: false,
            message: err.message,
        };
    }
};

export const uploadUserPhoto = (data, fileUrl, item) => async (dispatch) => {
    dispatch({ type: types.CHANGE_USER_PROFILE_PHOTO_STARTED });
    try {
        let headers = { "Content-Type": "multipart/form-data" };
        const response = await postFormCall(urls.uploadUserFileImage, data, headers);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.CHANGE_USER_PROFILE_PHOTO_SUCCEEDED,
                        payload: fileUrl,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.CHANGE_USER_PROFILE_PHOTO_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.CHANGE_USER_PROFILE_PHOTO_FAILED,
                });
                return false;
            }
        } else {
            dispatch({
                type: types.CHANGE_USER_PROFILE_PHOTO_FAILED,
            });
            return false;
        }
    } catch (err) {
        dispatch({ type: types.CHANGE_USER_PROFILE_PHOTO_FAILED, payload: err });
        return false;
    }
};

export const changeBusinessEmail = (data) => async (dispatch) => {
    dispatch({ type: types.UPDATE_BUSINESS_EMAIL_STARTED });
    try {
        const response = await postCall(urls.updateBusinessEmail, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.UPDATE_BUSINESS_EMAIL_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.UPDATE_BUSINESS_EMAIL_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.UPDATE_BUSINESS_EMAIL_FAILED,
                });
                interceptor(response, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.UPDATE_BUSINESS_EMAIL_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_BUSINESS_EMAIL_FAILED,
        });
        return false;
    }
};

export const businessEmailVerification = (data) => async (dispatch) => {
    dispatch({ type: types.VERIFY_BUSINESS_EMAIL_STARTED });
    try {
        const response = await postCall(urls.sendBusinessValidationEmail, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.VERIFY_BUSINESS_EMAIL_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.VERIFY_BUSINESS_EMAIL_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.VERIFY_BUSINESS_EMAIL_FAILED,
                });
                interceptor(response, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.VERIFY_BUSINESS_EMAIL_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.VERIFY_BUSINESS_EMAIL_FAILED,
        });
        return false;
    }
};

export const setLocalIpAddress = (key, value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCAL_IP,
        payload: {
            key: key,
            value: value,
        },
    });
};

export const setLocalAuditLogData = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCAL_AUDIT_LOG,
        payload: value,
    });
};

export const refreshToken = (payload, headers) => async (dispatch) => {
    dispatch({ type: types.RESET_AUTH_TOKEN_STARTED });
    try {
        const response = await postCall(urls.refreshToken, payload, "", headers);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.RESET_AUTH_TOKEN_SUCCEEDED,
                    });
                    return {
                        status: true,
                        data: response.data.data,
                    };
                } else {
                    dispatch({
                        type: types.RESET_AUTH_TOKEN_FAILED,
                    });
                    return {
                        status: false,
                        statusCode: status,
                    };
                }
            } else {
                dispatch({
                    type: types.RESET_AUTH_TOKEN_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                    statusCode: status,
                };
            }
        } else {
            dispatch({
                type: types.RESET_AUTH_TOKEN_FAILED,
            });

            interceptor(response, dispatch);
            return {
                status: false,
                statusCode: "",
            };
        }
    } catch (err) {
        dispatch({
            type: types.RESET_AUTH_TOKEN_FAILED,
        });
        return {
            status: false,
        };
    }
};

export const updateBusinessType = (data) => async (dispatch) => {
    dispatch({ type: types.UPDATE_BUSINESS_TYPE_STARTED });
    try {
        const response = await postCall(urls.updateBusinessType, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.UPDATE_BUSINESS_TYPE_SUCCEEDED,
                        payload: data.businessCategory,
                    });
                    return {
                        status: true,
                        data: response.data,
                    };
                } else {
                    dispatch({
                        type: types.UPDATE_BUSINESS_TYPE_FAILED,
                    });
                    return {
                        status: false,
                    };
                }
            } else {
                dispatch({
                    type: types.UPDATE_BUSINESS_TYPE_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                };
            }
        } else {
            dispatch({
                type: types.UPDATE_BUSINESS_TYPE_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_BUSINESS_TYPE_FAILED,
        });
        return {
            status: false,
        };
    }
};

export const initiateSetPin = (payload) => async (dispatch) => {
    dispatch({ type: types.INITIATE_SET_PIN_STARTED });
    try {
        const response = await postCall(urls.initiateSetPin, payload);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.INITIATE_SET_PIN_SUCCEEDED,
                    });
                    return {
                        status: true,
                        data: response.data,
                    };
                } else {
                    dispatch({
                        type: types.INITIATE_SET_PIN_FAILED,
                    });
                    return {
                        status: false,
                    };
                }
            } else {
                dispatch({
                    type: types.INITIATE_SET_PIN_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                };
            }
        } else {
            dispatch({
                type: types.INITIATE_SET_PIN_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.INITIATE_SET_PIN_FAILED,
        });
        return {
            status: false,
        };
    }
};

export const updateCACTIN =
    (data, isUpdate = false) =>
    async (dispatch, getState) => {
        dispatch({ type: types.UPDATE_CAC_TIN_STARTED });
        try {
            const response = await postCall(urls.updateSMEProfile, data);
            if (response.data) {
                const { status } = response;
                if (status === 200) {
                    if (response.data.isSuccessful) {
                        const { accountState } = getState();

                        const finalData = isUpdate
                            ? {
                                  ...data,
                                  cacNumber: accountState.singleSmeAccount.cacNumber,
                                  dateOfRegistration:
                                      accountState.singleSmeAccount.dateOfRegistration,
                              }
                            : { ...data };

                        dispatch({
                            type: types.UPDATE_CAC_TIN_SUCCEEDED,
                            payload: finalData,
                        });
                        return true;
                    } else {
                        dispatch({
                            type: types.UPDATE_CAC_TIN_FAILED,
                        });
                        return false;
                    }
                } else {
                    dispatch({
                        type: types.UPDATE_CAC_TIN_FAILED,
                    });
                    interceptor(status, dispatch);
                    return false;
                }
            } else {
                dispatch({
                    type: types.UPDATE_CAC_TIN_FAILED,
                });
                interceptor(response, dispatch);
            }
        } catch (err) {
            dispatch({
                type: types.UPDATE_CAC_TIN_FAILED,
            });
            return false;
        }
    };

export const updateChecks = (value) => (dispatch) => {
    dispatch({
        type: types.UPDATE_CHECKS,
        payload: value,
    });
};

export const prefillLimitedDocuments = (value) => (dispatch) => {
    dispatch({
        type: types.PREFILL_LIMITED_DOCUMENTS,
        payload: value,
    });
};

export const prefillBusinessDocuments = (value) => (dispatch) => {
    dispatch({
        type: types.PREFILL_BUSINESS_DOCUMENTS,
        payload: value,
    });
};

export const accountTypeSelected = (value) => async (dispatch) => {
    dispatch({ type: types.SET_ACCOUNT_SELECTED_STARTED });
    try {
        const response = await postCall(urls.updateBusinsessCategory, value);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.SET_ACCOUNT_SELECTED_SUCCEEDED,
                        payload: value.businessCategory,
                    });
                    return {
                        status: true,
                        data: value.businessCategory,
                    };
                } else {
                    dispatch({
                        type: types.SET_ACCOUNT_SELECTED_FAILED,
                    });
                    return {
                        status: false,
                    };
                }
            } else {
                dispatch({
                    type: types.SET_ACCOUNT_SELECTED_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                };
            }
        } else {
            dispatch({
                type: types.SET_ACCOUNT_SELECTED_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.SET_ACCOUNT_SELECTED_FAILED,
        });
        return {
            status: false,
        };
    }
};

export const showTransactionPinModal = (value) => (dispatch) => {
    dispatch({
        type: types.SHOW_TRANSACTION_PIN_MODAL,
        payload: value,
    });
};

export const setTermsStatus = () => (dispatch) => {
    dispatch({
        type: types.SET_TERMS_STATUS,
        payload: true,
    });
};

export const updateBusinessDetails = (payload) => async (dispatch) => {
    dispatch({ type: types.UPDATE_BUSINESS_DETAILS_STARTED });
    try {
        const response = await postCall(urls.updateBusinessDetails, payload);
        const { data, message } = response;
        if (response?.data) {
            if (data.isSuccessful === true) {
                dispatch({
                    type: types.UPDATE_BUSINESS_DETAILS_SUCCEEDED,
                    payload: payload,
                });
                return {
                    status: true,
                    message: message,
                };
            } else {
                dispatch({
                    type: types.UPDATE_BUSINESS_DETAILS_FAILED,
                });
                return {
                    status: false,
                    message: message,
                };
            }
        } else {
            dispatch({
                type: types.UPDATE_BUSINESS_DETAILS_FAILED,
            });

            return {
                status: false,
                message: message,
            };
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_BUSINESS_DETAILS_FAILED,
        });
        return {
            status: false,
            message: "Something went wrong. Please try again!",
        };
    }
};

export const updateTinNumber = (payload) => async (dispatch) => {
    dispatch({ type: types.UPDATE_TIN_NUMBER_STARTED });
    try {
        const response = await postCall(urls.updateBusinessDetails, payload);
        if (response.data) {
            const { status, data, message } = response;
            if (status === 200) {
                if (data.isSuccessful === true) {
                    dispatch({
                        type: types.UPDATE_TIN_NUMBER_SUCCEEDED,
                        payload: payload,
                    });
                    return {
                        status: true,
                        message: message,
                    };
                } else {
                    dispatch({
                        type: types.UPDATE_TIN_NUMBER_FAILED,
                    });
                    return {
                        status: false,
                        message: message,
                    };
                }
            } else {
                dispatch({
                    type: types.UPDATE_TIN_NUMBER_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                };
            }
        } else {
            dispatch({
                type: types.UPDATE_TIN_NUMBER_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_TIN_NUMBER_FAILED,
        });
        return {
            status: false,
        };
    }
};

export const updateCacDoc = (value) => (dispatch) => {
    dispatch({
        type: types.UPDATE_CAC_DOC,
        payload: value,
    });
};

export const UpdateOtherDoc = () => (dispatch) => {
    dispatch({
        type: types.UPDATE_OTHER_DOC,
        payload: true,
    });
};

export const transactionPinDone = () => (dispatch) => {
    dispatch({
        type: types.TRANSACTION_PIN_DONE,
        payload: true,
    });
};

export const closeStartBankingModal = () => (dispatch) => {
    dispatch({
        type: types.CLOSE_START_BANKING_MODAL,
    });
};

export const validateAndCreateAccount = (payload, fromInvitePage) => async (dispatch) => {
    dispatch({ type: types.VALIDATE_TOKEN_AND_CREATE_STARTED });
    try {
        const response = await postCall(urls.validateTokenAndCreateProfile, payload);

        if (response?.data?.isSuccessful) {
            const { data } = response;
            const profiles = data.data.groups;
            const newGroupID = data?.data?.validationResponse?.newGroupID;
            let groupAccount;

            if (fromInvitePage) {
                //check for invited user
                const profile = profiles?.filter((item) => item?.customerId === newGroupID);
                groupAccount = profile?.[0];
            } else {
                //check for normal signup
                groupAccount = profiles?.[0];
            }

            dispatch({
                type: types.VALIDATE_TOKEN_AND_CREATE_SUCCEEDED,
                payload: {
                    data: data?.data,
                    nominee: groupAccount?.nominee,
                    businessProfile: groupAccount?.businessProfile,
                    signatoryID: data?.data?.customerId,
                    smeProfileID: groupAccount?.businessProfile?.groupID,
                    accountNumber: groupAccount?.accounts[0]?.accountNumber,
                    groups: groupAccount,
                    tierLevel: groupAccount?.accounts[0]?.tierLevel,
                    kudaBusinessTier: data?.data?.kudaBusinessTier,
                },
            });

            // EXTRA CHECK to set missing properties from the dispatch above
            dispatch({
                type: types.SELECT_SME_PROFILE,
                payload: {
                    accounts: groupAccount?.accounts[0],
                    businessProfile: groupAccount?.businessProfile,
                    nominee: groupAccount?.nominee,
                    data: groupAccount,
                    raw: data?.data,
                },
            });

            return {
                status: true,
                userID: data?.data?.customerId,
                tokens: data?.data?.validationResponse,
                email: data?.data?.email,
                accountNumber: groupAccount?.accounts[0]?.accountNumber,
                smeProfileID: groupAccount?.businessProfile?.groupID,
                message: data?.message,
            };
        } else {
            dispatch({
                type: types.VALIDATE_TOKEN_AND_CREATE_FAILED,
                payload: "Account Creation failed",
            });
            // interceptor(response, dispatch);
            return {
                status: false,
                message: "Account Creation failed",
            };
        }
    } catch (err) {
        dispatch({
            type: types.VALIDATE_TOKEN_AND_CREATE_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
            message: "Account Creation failed",
        };
    }
};

export const validateAndCreateProfile = (payload, fromInvitePage) => async (dispatch) => {
    dispatch({ type: types.VALIDATE_TOKEN_AND_CREATE_PROFILE_STARTED });
    try {
        const response = await postCall(urls.validateTokenAndCreateProfile, payload);
        if (response?.data.isSuccessful) {
            dispatch({
                type: types.VALIDATE_TOKEN_AND_CREATE_PROFILE_SUCCEEDED,
                payload: response?.data?.data,
            });
            return {
                status: response?.data?.isSuccessful,
                message: response?.data?.message || "",
                data: response?.data?.data || {},
                statusCode: response?.data?.statusCode || "",
            };
        } else {
            return {
                status: response?.data?.isSuccessful,
                statusCode: response?.data?.statusCode || "",
                message: response?.data?.message || "",
            };
        }
    } catch (err) {
        dispatch({
            type: types.VALIDATE_TOKEN_AND_CREATE_PROFILE_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const updateCacDocState = (payload) => async (dispatch) => {
    dispatch({ type: types.UPDATE_CACDOCSTATE_UPDATE_STARTED });
    try {
        const response = await postCall(urls.updateBusinessDetails, payload);
        if (response.data) {
            const { status, data, message } = response;
            if (status === 200) {
                if (data.isSuccessful === true) {
                    dispatch({
                        type: types.UPDATE_CACDOCSTATE_UPDATE_SUCCEEDED,
                        payload: payload,
                    });
                    return {
                        status: true,
                        message: message,
                    };
                } else {
                    dispatch({
                        type: types.UPDATE_CACDOCSTATE_UPDATE_FAILED,
                    });
                    return {
                        status: false,
                        message: message,
                    };
                }
            } else {
                dispatch({
                    type: types.UPDATE_CACDOCSTATE_UPDATE_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                };
            }
        } else {
            dispatch({
                type: types.UPDATE_CACDOCSTATE_UPDATE_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_CACDOCSTATE_UPDATE_FAILED,
        });
        return {
            status: false,
        };
    }
};

export const createNomineeTransactionPin = (data) => async (dispatch) => {
    dispatch({
        type: types.CREATE_PIN_STARTED,
    });
    try {
        const response = await postCall(urls.createTransactionPin, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.CREATE_PIN_SUCCEEDED,
                    });
                    return {
                        status: true,
                        message: response.data.message,
                    };
                } else {
                    dispatch({
                        type: types.CREATE_PIN_FAILED,
                    });
                    return {
                        status: false,
                        message: response.data.message,
                    };
                }
            } else {
                dispatch({
                    type: types.CREATE_PIN_FAILED,
                });
                interceptor(status, dispatch);
                return {
                    status: false,
                    message: "Sorry, an error occurred. Please try again",
                };
            }
        } else {
            dispatch({
                type: types.CREATE_PIN_FAILED,
            });
            interceptor(response, dispatch);
            return {
                status: false,
                message: "Sorry, an error occurred. Please try again",
            };
        }
    } catch (err) {
        dispatch({
            type: types.CREATE_PIN_FAILED,
            payload: err,
        });
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const createAdditionalBusinessAccount = (payload) => async (dispatch) => {
    dispatch({ type: types.VALIDATE_TOKEN_AND_CREATE_STARTED });
    try {
        const response = await postCall(urls.createAdditionalBusiness, payload);
        if (response?.data) {
            const { status, data } = response;
            if (status === 200) {
                if (data?.isSuccessful && data?.statusCode === "k00") {
                    const profiles = data.data.groups;
                    const newGroupID = data.data.validationResponse.newGroupID;
                    let groupAccount;
                    const profile = profiles.filter((item) => item.customerId === newGroupID);
                    groupAccount = profile[0];
                    dispatch({
                        type: types.VALIDATE_TOKEN_AND_CREATE_SUCCEEDED,
                        payload: {
                            data: data?.data,
                            nominee: groupAccount.nominee,
                            businessProfile: groupAccount?.businessProfile,
                            signatoryID: data?.data?.customerId,
                            smeProfileID: groupAccount?.businessProfile?.groupID,
                            accountNumber: groupAccount?.accounts[0]?.accountNumber,
                            groups: groupAccount,
                            tierLevel: groupAccount?.accounts[0]?.tierLevel,
                            kudaBusinessTier: data?.data?.kudaBusinessTier,
                        },
                    });

                    // EXTRA CHECK to set missing properties from the dispatch above
                    dispatch({
                        type: types.SELECT_SME_PROFILE,
                        payload: {
                            accounts: groupAccount.accounts[0],
                            businessProfile: groupAccount.businessProfile,
                            nominee: groupAccount.nominee,
                            data: groupAccount,
                            raw: data.data,
                        },
                    });
                    return {
                        status: true,
                        userID: data?.data?.customerId,
                        tokens: data?.data?.validationResponse,
                        email: data?.data?.email,
                        accountNumber: groupAccount?.accounts[0]?.accountNumber,
                        smeProfileID: groupAccount?.businessProfile?.groupID,
                        message: data?.message,
                    };
                } else {
                    dispatch({
                        type: types.VALIDATE_TOKEN_AND_CREATE_FAILED,
                        payload: "Account Creation failed",
                    });
                    return {
                        status: false,
                        message: data.message,
                    };
                }
            } else {
                dispatch({
                    type: types.VALIDATE_TOKEN_AND_CREATE_FAILED,
                    payload: "Account Creation failed",
                });
                interceptor(status, dispatch);
                return {
                    status: false,
                    message: "Account Creation failed",
                };
            }
        } else {
            dispatch({
                type: types.VALIDATE_TOKEN_AND_CREATE_FAILED,
                payload: "Account Creation failed",
            });
            interceptor(response, dispatch);
            return {
                status: false,
                message: "Account Creation failed",
            };
        }
    } catch (err) {
        dispatch({
            type: types.VALIDATE_TOKEN_AND_CREATE_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
            message: "Account Creation failed",
        };
    }
};

export const updateIsDirectorIndemnityAgreed = (payload) => async (dispatch) => {
    dispatch({ type: types.UPDATE_IS_DIRECTOR_INDEMNITY_STARTED });
    try {
        const response = await postCall(urls.updateBusinessDetails, payload);
        if (response.data) {
            const { status, data, message } = response;
            if (status === 200) {
                if (data.isSuccessful === true) {
                    dispatch({
                        type: types.UPDATE_IS_DIRECTOR_INDEMNITY_SUCCEEDED,
                        payload: payload,
                    });
                    return {
                        status: true,
                        message: message,
                    };
                } else {
                    dispatch({
                        type: types.UPDATE_IS_DIRECTOR_INDEMNITY_FAILED,
                    });
                    return {
                        status: false,
                        message: message,
                    };
                }
            } else {
                dispatch({
                    type: types.UPDATE_IS_DIRECTOR_INDEMNITY_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                    message: "Something went wrong. Please try again!",
                };
            }
        } else {
            dispatch({
                type: types.UPDATE_IS_DIRECTOR_INDEMNITY_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.UPDATE_IS_DIRECTOR_INDEMNITY_FAILED,
        });
        return {
            status: false,
            message: "Something went wrong. Please try again!",
        };
    }
};

export const updateNOKInfo = (data) => async (dispatch) => {
    dispatch({ type: types.USER_NOK_INFO_UPDATE_STARTED });
    try {
        const response = await postCall(urls.updateNokDetails, data);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful) {
                    dispatch({
                        type: types.USER_NOK_INFO_UPDATE_SUCCEEDED,
                        payload: data,
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.USER_NOK_INFO_UPDATE_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.USER_NOK_INFO_UPDATE_FAILED,
                });
                interceptor(status, dispatch);
                return false;
            }
        } else {
            dispatch({
                type: types.USER_NOK_INFO_UPDATE_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.USER_NOK_INFO_UPDATE_FAILED,
        });
        return false;
    }
};

export const sendBusinessEmailValidationToken = (payload) => async (dispatch) => {
    dispatch({ type: types.SEND_BUSINESS_EMAIL_TOKEN_STARTED });
    try {
        const response = await postCall(urls.sendValidationTokenForBusinessEmails, payload);
        if (response.data) {
            const { status, data } = response;
            if (status === 200) {
                if (data.isSuccessful === true) {
                    dispatch({
                        type: types.SEND_BUSINESS_EMAIL_TOKEN_SUCCEEDED,
                        payload: payload,
                    });
                    return {
                        status: true,
                        message: data.message,
                    };
                } else {
                    dispatch({
                        type: types.SEND_BUSINESS_EMAIL_TOKEN_FAILED,
                    });
                    return {
                        status: false,
                        message: data.message,
                    };
                }
            } else {
                dispatch({
                    type: types.SEND_BUSINESS_EMAIL_TOKEN_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                    message: "Something went wrong. Please try again!",
                };
            }
        } else {
            dispatch({
                type: types.SEND_BUSINESS_EMAIL_TOKEN_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.SEND_BUSINESS_EMAIL_TOKEN_FAILED,
        });
        return {
            status: false,
            message: "Something went wrong. Please try again!",
        };
    }
};

export const validateBusinessEmailToken = (payload) => async (dispatch) => {
    dispatch({ type: types.VALIDATE_BUSINESS_EMAIL_TOKEN_STARTED });
    try {
        const response = await postCall(urls.verifyBusinessEmailToken, payload);
        if (response.data) {
            const { status, data } = response;
            if (status === 200) {
                if (data.isSuccessful === true) {
                    dispatch({
                        type: types.VALIDATE_BUSINESS_EMAIL_TOKEN_SUCCEEDED,
                        payload: payload,
                    });
                    return {
                        status: true,
                        message: data.message,
                    };
                } else {
                    dispatch({
                        type: types.VALIDATE_BUSINESS_EMAIL_TOKEN_FAILED,
                    });
                    return {
                        status: false,
                        message: data.message,
                    };
                }
            } else {
                dispatch({
                    type: types.VALIDATE_BUSINESS_EMAIL_TOKEN_FAILED,
                });
                interceptor(response, dispatch);
                return {
                    status: false,
                    message: "Something went wrong. Please try again!",
                };
            }
        } else {
            dispatch({
                type: types.VALIDATE_BUSINESS_EMAIL_TOKEN_FAILED,
            });
            interceptor(response, dispatch);
        }
    } catch (err) {
        dispatch({
            type: types.VALIDATE_BUSINESS_EMAIL_TOKEN_FAILED,
        });
        return {
            status: false,
            message: "Something went wrong. Please try again!",
        };
    }
};

export const ntbCreateAccount = (payload, fromInvitePage) => async (dispatch) => {
    dispatch({ type: types.NTB_CREATE_ACCOUNT_STARTED });
    try {
        const response = await postCall(urls.ntbCreateAccount, payload);
        const { status, data } = response;
        if (status === 200) {
            if (response.data.isSuccessful) {
                const profiles = data?.data?.groups;
                const newGroupID = data?.data?.validationResponse?.newGroupID;
                let groupAccount;
                if (fromInvitePage) {
                    //check for invited user
                    const profile = profiles.filter((item) => item?.customerId === newGroupID);
                    groupAccount = profile[0];
                } else {
                    //check for normal signup
                    groupAccount = profiles[0];
                }
                dispatch({
                    type: types.VALIDATE_TOKEN_AND_CREATE_SUCCEEDED,
                    payload: {
                        data: data?.data,
                        nominee: groupAccount?.nominee,
                        businessProfile: groupAccount?.businessProfile,
                        signatoryID: data?.data?.customerId,
                        smeProfileID: groupAccount?.businessProfile?.groupID,
                        accountNumber: groupAccount?.accounts[0]?.accountBalance?.accountNumber,
                        groups: groupAccount,
                        tierLevel: groupAccount?.accounts[0]?.tierLevel,
                        kudaBusinessTier: data.data.kudaBusinessTier,
                    },
                });
                // return {
                //     status: true,
                //     userID: data?.data?.customerId,
                //     tokens: data?.data?.validationResponse,
                //     email: data?.data.email,
                //     accountNumber:
                //         groupAccount.accounts[0].accountBalance.accountNumber,
                //     smeProfileID: groupAccount.businessProfile.groupID,
                //     message: data?.message,
                // };
                dispatch({
                    type: types.NTB_CREATE_ACCOUNT_SUCCEEDED,
                    payload: {
                        status: true,
                        message: "success",
                    },
                });
                return {
                    status: true,
                    message: data?.message,
                    tokens: data?.data?.validationResponse,
                    userID: data?.data?.customerId,
                    kudaBusinessTier: data.data.kudaBusinessTier,
                };
            } else {
                dispatch({
                    type: types.NTB_CREATE_ACCOUNT_FAILED,
                    payload: "Validation failed",
                });
                return {
                    status: false,
                    message: data?.message,
                };
            }
        } else {
            dispatch({
                type: types.NTB_CREATE_ACCOUNT_FAILED,
                payload: "Validation failed",
            });
            interceptor(response, dispatch);
            return {
                status: false,
                message: data?.message,
            };
        }
    } catch (err) {
        dispatch({
            type: types.NTB_CREATE_ACCOUNT_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const ntbUpdateBVN = (payload) => async (dispatch) => {
    dispatch({ type: types.ADD_BVN_STARTED });
    try {
        const response = await postCall(urls.ntbAddBvn, payload);
        if (response.data) {
            const { status, data } = response;
            if (status === 200) {
                if (data.isSuccessful === true) {
                    dispatch({
                        type: types.ADD_BVN_SUCCEEDED,
                        payload: payload,
                    });
                    return {
                        status: true,
                        message: data.message,
                        data: data.data,
                    };
                } else {
                    dispatch({
                        type: types.ADD_BVN_FAILED,
                    });
                    return {
                        status: false,
                        message: data.message,
                    };
                }
            } else {
                dispatch({
                    type: types.ADD_BVN_FAILED,
                });
                // interceptor(response, dispatch);
                return {
                    status: false,
                    message: "Something went wrong. Please try again!",
                };
            }
        } else {
            dispatch({
                type: types.ADD_BVN_FAILED,
            });
            // interceptor(response, dispatch);
            return {
                status: false,
                message: "Something went wrong. Please try again!",
            };
        }
    } catch (err) {
        dispatch({
            type: types.ADD_BVN_FAILED,
        });
        return {
            status: false,
            message: "Something went wrong. Please try again!",
        };
    }
};

export const ntbBvnDocFlag = (payload, reduxPayload) => async (dispatch) => {
    dispatch({ type: types.BVN_DOC_FLAG_UPDATE_STARTED });
    try {
        const response = await postCall(urls.ntbUpdateMatiFlag, payload);
        if (response.data) {
            const { status, data } = response;
            if (status === 200) {
                if (data.isSuccessful === true) {
                    dispatch({
                        type: types.BVN_DOC_FLAG_UPDATE_SUCCEEDED,
                        payload: reduxPayload,
                    });
                    return {
                        status: true,
                        message: data.message,
                    };
                } else {
                    dispatch({
                        type: types.BVN_DOC_FLAG_UPDATE_FAILED,
                    });
                    return {
                        status: false,
                        message: data.message,
                    };
                }
            } else {
                dispatch({
                    type: types.BVN_DOC_FLAG_UPDATE_FAILED,
                });
                // interceptor(response, dispatch);
                return {
                    status: false,
                    message: "Something went wrong. Please try again!",
                };
            }
        } else {
            dispatch({
                type: types.BVN_DOC_FLAG_UPDATE_FAILED,
            });
            // interceptor(response, dispatch);
            return {
                status: false,
                message: "Something went wrong. Please try again!",
            };
        }
    } catch (err) {
        dispatch({
            type: types.BVN_DOC_FLAG_UPDATE_FAILED,
        });
        return {
            status: false,
            message: "Something went wrong. Please try again!",
        };
    }
};

export const uploadValidID = (data, fileUrl, item) => async (dispatch) => {
    dispatch({ type: types.UPLOAD_VALID_ID_STARTED });
    try {
        let headers = { "Content-Type": "multipart/form-data" };
        const response = await postFormCall(urls.uploadUserFileImage, data, headers);
        if (response.data) {
            const { status } = response;
            if (status === 200) {
                if (response.data.isSuccessful === true) {
                    dispatch({
                        type: types.UPLOAD_VALID_ID_SUCCEEDED,
                        payload: {
                            name: item,
                            data: fileUrl,
                        },
                    });
                    return true;
                } else {
                    dispatch({
                        type: types.UPLOAD_VALID_ID_FAILED,
                    });
                    return false;
                }
            } else {
                dispatch({
                    type: types.UPLOAD_VALID_ID_FAILED,
                });
                return false;
            }
        } else {
            dispatch({
                type: types.UPLOAD_VALID_ID_FAILED,
            });
            return false;
        }
    } catch (err) {
        dispatch({ type: types.UPLOAD_VALID_ID_FAILED, payload: err });
        return false;
    }
};

export const ntbCreateAccountInvited = (payload, fromInvitePage) => async (dispatch) => {
    dispatch({ type: types.NTB_CREATE_ACCOUNT_STARTED });
    try {
        const response = await postCall(urls.ntbCreateAccount, payload);
        const { status, data } = response;
        if (status === 200) {
            if (response.data.isSuccessful) {
                const profiles = data?.data?.groups;
                const newGroupID = data?.data?.validationResponse?.newGroupID;
                let groupAccount;
                if (fromInvitePage) {
                    //check for invited user
                    const profile = profiles.filter((item) => item?.customerId === newGroupID);
                    groupAccount = profile[0];
                } else {
                    //check for normal signup
                    groupAccount = profiles[0];
                }
                dispatch({
                    type: types.VALIDATE_TOKEN_AND_CREATE_SUCCEEDED,
                    payload: {
                        data: data?.data,
                        nominee: groupAccount?.nominee,
                        businessProfile: groupAccount?.businessProfile,
                        signatoryID: data?.data?.customerId,
                        smeProfileID: groupAccount?.businessProfile?.groupID,
                        accountNumber: groupAccount?.accounts[0]?.accountNumber,
                        groups: groupAccount,
                        tierLevel: groupAccount?.accounts[0]?.tierLevel,
                        kudaBusinessTier: data.data.kudaBusinessTier,
                    },
                });
                return {
                    status: true,
                    userID: data?.data?.customerId,
                    tokens: data?.data?.validationResponse,
                    email: data?.data.email,
                    accountNumber: groupAccount.accounts[0]?.accountNumber,
                    smeProfileID: groupAccount.businessProfile.groupID,
                    message: data?.message,
                    accessLevel: groupAccount?.nominee?.accessLevel,
                };
            } else {
                dispatch({
                    type: types.NTB_CREATE_ACCOUNT_FAILED,
                    payload: "Validation failed",
                });
                return {
                    status: false,
                    message: data?.message,
                };
            }
        } else {
            dispatch({
                type: types.NTB_CREATE_ACCOUNT_FAILED,
                payload: "Validation failed",
            });
            interceptor(response, dispatch);
            return {
                status: false,
                message: data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (err) {
        dispatch({
            type: types.NTB_CREATE_ACCOUNT_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const updateKudaBusinessTier = () => async (dispatch) => {
    dispatch({
        type: types.UPDATE_KUDA_BUSINESS_TIER,
    });
};
// -----------   DASHBOARD REDESIGN ENDPOINT ---------------

export const fetchDailyTransferVolume = (data) => async (dispatch) => {
    dispatch({
        type: types.FETCH_DAILY_TRANSACTION_VOLUME_LOADING,
    });
    try {
        const response = await postCall(urls.dailyTransferVolume, data);
        dispatch({
            type: types.FETCH_DAILY_TRANSACTION_VOLUME_SUCCEEDED,
            payload: response.data.data,
        });
    } catch (err) {
        dispatch({
            type: types.FETCH_DAILY_TRANSACTION_VOLUME_FAILED,
            payload: "Please check your internet connection and try again!",
        });
        return false;
    }
};

export const fetchTransferLimitSettings = (data) => async (dispatch) => {
    dispatch({
        type: types.FETCH_TRANSACTION_LIMIT_LOADING,
    });
    try {
        const response = await postCall(urls.transferLimitSettings, data);
        dispatch({
            type: types.FETCH_TRANSACTION_LIMIT_SUCCEEDED,
            payload: response.data.data,
        });
    } catch (err) {
        dispatch({
            type: types.FETCH_TRANSACTION_LIMIT_FAILED,
            payload: "Please check your internet connection and try again!",
        });
        return false;
    }
};

export const storeFreshChatRestoreId = (data) => async (dispatch) => {
    dispatch({
        type: types.STORE_RESTORE_ID_STARTED,
    });
    try {
        const response = await postCall(urls.storeRestoreId, data);
        dispatch({
            type: types.STORE_RESTORE_ID_SUCCEEDED,
            payload: response.data.data,
        });
    } catch (err) {
        dispatch({
            type: types.STORE_RESTORE_ID_FAILED,
            payload: "Please check your internet connection and try again!",
        });
        return false;
    }
};

export const updateLegalSearchChargeStatus = (status) => async (dispatch) => {
    dispatch({
        type: types.UPDATE_LEGAL_SEARCH_CHARGE_STATUS,
        payload: status,
    });
};

export const createBusinessCategory =
    (data, isUpdate = false) =>
    async (dispatch) => {
        dispatch({ type: types.CREATE_BUSINESS_CATEGORY_STARTED });

        const endpoint = isUpdate ? urls.updateBusinessCategoryGroup : urls.createBusinessCategory;

        try {
            const response = await postCall(endpoint, data);
            if (response?.data?.status) {
                dispatch({
                    type: types.CREATE_BUSINESS_CATEGORY_SUCCEEDED,
                    payload: response.data.data,
                });
            } else {
                dispatch({ type: types.CREATE_BUSINESS_CATEGORY_FAILED });
            }

            return response;
        } catch (err) {
            dispatch({
                type: types.CREATE_BUSINESS_CATEGORY_FAILED,
            });
            return {
                status: false,
                message: err?.response?.data || err?.message,
            };
        }
    };

export const createBusinessAccount = (data) => async (dispatch) => {
    dispatch({ type: types.CREATE_BUSINESS_ACCOUNT_STARTED });
    try {
        const response = await postCall(urls.createBusinessAccount, data);
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.CREATE_BUSINESS_ACCOUNT_SUCCEEDED,
                payload: response.data.data.accountNumber,
            });
        } else {
            dispatch({ type: types.CREATE_BUSINESS_ACCOUNT_FAILED });
        }

        return response;
    } catch (err) {
        dispatch({
            type: types.CREATE_BUSINESS_ACCOUNT_FAILED,
        });
        return {
            status: false,
            message: err?.response?.data || err?.message,
        };
    }
};
